import React from 'react'
import About from './About'
import ObjectRenderer from './ObjectRenderer'

export default class AboutPage extends React.Component {
  state={}
  componentDidMount() {
  }
  render() {
    const {className} = this.props
    return (
      <div className={`main-content ${className||''}`}>
        <h1 className="text-center">About</h1>
        <ObjectRenderer value={About} />
      </div>
    )
  }
}
